import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/core/services/user.service';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';
import {Router, ActivatedRoute} from '@angular/router';
import { BaseService } from 'src/app/core/services/base.service';
import { Config } from 'src/app/config/constants';
@Component({
  selector: 'app-policy-full-refund',
  templateUrl: './policy-full-refund.component.html',
  styleUrls: ['./policy-full-refund.component.scss'],
  providers: [DatePipe],
})


  export class PolicyFullRefundComponent implements OnInit {


    showSearchedPolicy:boolean=false;
    showPolicyDetails:boolean=false;
    showPolicySearch:boolean=true;
    showRefundPolicy:boolean=false;
    showAudtiLogs:boolean=false;
    selectedPolicyId:any;
    editcreditCardDetails: any=[];
    cardType:any
    agentId: any;
  sslCardNumber:any;
  sslCardShortDescription:any
  sslCardType:any
  sslCvv2Response:any
  sslExpDate:any
  sslTransactionType:any
  minDate = new Date();
  startDate: any;
  minDate1 = new Date()
  minDateArrival= new Date();
  showarrivalDateInCanadaPopup:boolean=false;
  createdDate:any;
    adminFee: any;
    adminFeeReason: any;
    Amount: any;
    cardType1: any;
    CardNumber1: any;
     cardexpdate1: any;
     cvv1: any;
    Amount2: any;
  Amount3: any;
  Amount4: any;
  Amount5: any;
  cardType2: any;
  cardType3: any;
  cardType4: any;
  cardType5: any;
  cvv2: any;
  cvv3: any;
  cvv4: any;
  cvv5: any;
  CardNumber2: any;
  CardNumber3: any;
  CardNumber4: any;
  CardNumber5: any;
  cardexpdate2: any;
  cardexpdate3: any;
  cardexpdate4: any;
  cardexpdate5: any;
    AmounttoPay: any;
    ssl_card_number1: any;
  ssl_exp_date1: any;
  ssl_cvv2_response1: any;
  ssl_card_type1: any;
  ssl_card_number: any;
  ssl_card_type: any;
   ssl_exp_date : any;
   ssl_cvv2_response:any
    policypaymentdetailsArray: any=[];
    policypaymentdetailsArray1: any=[];
    creditCardDetails: any;
    PrevAmount: any;
   
    showCardNo1:boolean=false;
    showCardNo2:boolean=false;
    showCardNo3:boolean=false;
    showCardNo4:boolean=false;
    showCardNo5:boolean=false;
    showCVV1:boolean=false;
    showCVV2:boolean=false;
    showCVV3:boolean=false;
    showCVV4:boolean=false;
    showCVV5:boolean=false;
    showexp1:boolean=false;
    showexp2:boolean=false;
    showexp3:boolean=false;
    showexp4:boolean=false;
    showexp5:boolean=false;
    cardInfo: any=[];
    hideQuotePurchase:any;
  paymentTokenNew: any;
  checkOVRInAgencyCode: any;
  expDate1ToSend:any
  expDateYearToSend:any
  cardexpdate1Flag:boolean=false
  cardexpdate2Flag:boolean=false
  cardexpdate3Flag:boolean=false
  cardexpdate4Flag:boolean=false
  cardexpdate5Flag:boolean=false
  cardexpdateFlagButtonDisable:boolean=false
  leadsId: any;
  agentIdActive: string;
  leadStatus: any;
    constructor(public userservice: UserService,private datePipe: DatePipe,private base: BaseService,private config:Config,public user: UserService,private router: Router) { }
  
    ngOnInit() {
      
      this.policyId=localStorage.getItem('tlSalesAdminPolicyAdmin');
      this.hideQuotePurchase=sessionStorage.getItem('hideQuotePurchase');
      this.checkOVRInAgencyCode=sessionStorage.getItem('checkOVRInAgencyCode');
      this.getPolicyByIdSalesAdmin();
      this.addFirstValueTraveller();
      this.minDate.setHours(0, 0, 0, 0);
      this.minDate1.setHours(0, 0, 0, 0);
      this.minDateArrival.setHours(0, 0, 0, 0);
      this.minDateArrival.setHours(0, 0, 0, 0);
      this.leadsId=sessionStorage.getItem('leadId');
this.agentId=sessionStorage.getItem('agentIdSalesPortal');
this.getLeadAgentsCodes();
      this.insuredPerson();
      this.getcountryListing();
      this.getAllProvinces();
      this.getDashboard();
      let morningSlotDate = new Date();
      this.createdDate = this.datePipe.transform(morningSlotDate, "MM/dd/yyyy");
    }
    applicationEndDate ="";
    applicationStartDate ="";
    creditCardNumber ="";
    departureEndDate ="";
    departureStartDate ="";
    effectiveEndDate ="";
    effectiveStartDate ="";
    firstName ="";
    lastName ="";
    policyNumber ="";
    agencyCode="";
    onClickPolicySearch(){
      this.showSearchedPolicy = true;
      if(!this.policyNumber && !this.lastName && !this.firstName && !this.effectiveStartDate
        && !this.departureStartDate && !this.departureEndDate && !this.creditCardNumber && !this.applicationStartDate
        && !this.applicationEndDate){
          this.getAllPolicyForSalesAdmin();
        }else{
          this.searchFilterPolicy();
        }
    }
    policyId: any;
    policyInsureds=[];
    getPolicyData=[];
    selectedPlans=[];
    policyQuestionAnswers=[];
    transactionDetails=[];
    policyNumber1: any;
    txnId: any;
    refundPolicyReason: any;
    onClickPolicyNumber(id,number){
  
      this.showPolicyDetails=true;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
      this.showPolicySearch=false;
      this.selectedPolicyId=this.policyId;
      this.policyNumber = number;
      this.userservice.getPolicyById1(this.policyId).pipe()
      .subscribe(
          data => {
            
            this.purchasePostalCode=data.data.purchaserAddressPostalCode;
            
  this.purchaserAddress1=data.data.purchaserAddress1;
      this.policyInsureds = data.data.policyInsureds;
      this.selectedPlans = data.data.plans;
      this.policyQuestionAnswers = data.data.policyQuestionAnswers;
      this.getPolicyData.push(data.data);
      this.transactionDetails = data.data.transactions;
      this.creditCardDetails = data.data.creditCardDetails;
      this.policypaymentdetailsArray=[]
        for(let k=0;k<data.data.transactions.length;k++){
          if(data.data.transactions[k].transactionPaymentDetails[0].sslTransactionType!="RETURN"){
          this.policypaymentdetailsArray.push(data.data.transactions[k])
        }
        }
      this.policypaymentdetailsArray1=[]
        for(let k=0;k<data.data.transactions.length;k++){
          
          this.policypaymentdetailsArray1.push(data.data.transactions[k])

        }
      // if(data.data.transactions != null ){
      //   this.txnId = data.data.transactions[0].transactionPaymentDetails[0].sslTxnId
      //   this.Amount = data.data.transactions[0].transactionPaymentDetails[0].sslAmount
      //   this.PrevAmount = data.data.transactions[0].transactionPaymentDetails[0].sslAmount
      //   this.ssl_card_number=data.data.transactions[0].transactionPaymentDetails[0].sslCardNumber;
      //   this.ssl_card_type = data.data.transactions[0].transactionPaymentDetails[0].sslCardType
      //   this.ssl_exp_date = data.data.transactions[0].transactionPaymentDetails[0].sslExpDate
      //   this.ssl_cvv2_response = data.data.transactions[0].transactionPaymentDetails[0].sslCvv2Response
        
      // }
          },error=>{},()=>{});
       this.getPolicyByIdSalesAdmin();
    }
    backToPolicySearch(){
      // this.showSearchedPolicy=true;
      // this.showPolicyDetails=false;
      // this.showPolicySearch=true;
      // this.showRefundPolicy=false;
      // this.showAudtiLogs=false;
      // this.showChangePolicy=false;
      // this.showEditBillingInformation=false;
      this.router.navigateByUrl('/dashboard/policy-search');
    }
    onClickRefundPolicy(){
      // this.showSearchedPolicy=false;
      // this.showPolicyDetails=false;
      // this.showPolicySearch=false;
      // this.showRefundPolicy=true;
      // this.showAudtiLogs=false;
      this.router.navigateByUrl('/dashboard/policy-full-refund');
    }
  
    showRemove:boolean=false;
    insuredCount=1;
    numberOFInsured:any=0;
    incNumberOfInsured(){
      // if(this.numberOFInsured !=9){
      //   this.numberOFInsured++;
      // }
      if(this.insuredCount !=9){
        this.insuredCount++
        this.numberOFInsured =this.insuredCount;
        this.addFirstValueTraveller();
        if(this.insuredCount>1){
          this.showRemove=true;
        }else{
          this.showRemove=false;
        }
      }
    }
    minusNumberOfInsured(){
      // if(this.numberOFInsured < 10 && this.numberOFInsured > 0){
      //   this.numberOFInsured--;
      // }
      if(this.insuredCount < 10 && this.insuredCount > 1){
        this.numberOFInsured = this.insuredCount
        this.insuredCount--
        this.travellerInfo.splice(this.insuredCount, 1);
        if(this.insuredCount >1){
          this.showRemove=true;
         }else{
           this.showRemove=false; 
         }
      }
    }
  
    minusNumberOfInsuredShort(i){
      if(this.insuredCount < 10 && this.insuredCount > 0){
        this.numberOFInsured--;
        this.insuredCount--
        this.travellerInfo.splice(i, 1);
        if(this.insuredCount>1){
          this.showRemove=true;
         }else{
           this.showRemove=false; 
         }
      }
    }
   
    // minDate = new Date();
    // minDate1 = new Date()
    // minDateArrival= new Date();
    startDateFlag: boolean=false;
    // startDate: any;
  
    callStartDateFunction(event){
    if(this.startDate){
      this.startDateFlag=false;
      this.minDate=this.startDate;
      this.minDateArrival=this.startDate;
      for(let i=0;i<this.travellerInfo.length;i++){
          this.travellerInfo[i].arrivalDateOfCanada=null;
          this.travellerInfo[i].waitPeroid=null;
      }
    if(this.expiryDate){
        const dateTwo = new Date(new Date(this.startDate).setDate(this.startDate.getDate() + this.calculatedDays));
        this.expiryDate=dateTwo;
        this.minDateArrival = new Date(this.startDate)
      }
      }
      for(let i=0;i<this.travellerInfo.length;i++){
        if(!this.startDate){
          this.travellerInfo[i].arrivalDateOfCanada=null;
          this.travellerInfo[i].waitPeroid=null;
        }
      }
    }
  
    errorNegative:boolean=false;
    expiryDateFlag: boolean=false;
    expiryDate: any;
    calculatedDays: any=0;
    callExpiryDateFunction(event){
      // this.startDateFlag=false;
      if(this.calculatedDays<0){
        this.errorNegative=true;
      }else{
        this.errorNegative=false;
      if(this.expiryDate){
      var Time = this.expiryDate.getTime() - this.startDate.getTime(); 
      var Days = Time / (1000 * 3600 * 24); //Diference in Days
      this.calculatedDays=Days;
      this.expiryDateFlag=false;
      }}
    }
  
    callCalculatedDaysFunction(){
      if(this.calculatedDays<0){
        this.errorNegative=true;
      }else{
        this.errorNegative=false;
      if(this.startDate){
      const dateTwo = new Date(new Date(this.startDate).setDate(this.startDate.getDate() + parseInt(this.calculatedDays)));
      this.expiryDate=dateTwo;
      }else{
        window.alert("Need valid start date before adding no of days.")  
      }
      }
    }
    
  dobFlag: boolean = false;
  ageErrorCross: boolean=false;
  callDateOfBirth(event){
    for(let i=0;i<this.travellerInfo.length;i++){
      var timeDiff = Math.abs(Date.now() - this.travellerInfo[i].dateOfBirth.getTime());
      var ageCalculate = Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
      this.travellerInfo[i].age=ageCalculate;
      if(this.travellerInfo[i].age > 69){
        this.ageErrorCross = true;
      }else{
        this.ageErrorCross = false;
      }
      this.dobFlag=false;
    }
  }
  
  innerPop: boolean=false;
  selectedQuestionAns1: any;
  currentIndex: any=0;
  arrivalDateCanadaFlag: boolean=false;
  callArriveCanadaDate(event){
    if(this.startDate){
    for(let i=0;i<this.travellerInfo.length;i++){
      var Time = this.startDate.getTime() - this.travellerInfo[i].arrivalDateOfCanada.getTime(); 
      var Days = Time / (1000 * 3600 * 24); //Diference in Days
      if(Days>=1 && Days <=30){
        this.showarrivalDateInCanadaPopup=true;
        this.currentIndex = i
      }else if(Days>=30){
        this.showarrivalDateInCanadaPopup=true;
        this.currentIndex = i
      }
      else{
        this.travellerInfo[i].waitPeroid="None";
        this.showarrivalDateInCanadaPopup=false;
        this.currentIndex = i
      }
    }
    this.arrivalDateCanadaFlag=false;
  }else{
    window.alert("Need valid expiry/start date to calculate the wait period of your policy.")
    for(let i=0;i<this.travellerInfo.length;i++){
        this.travellerInfo[i].arrivalDateOfCanada=null;
      }
  }
  }
    travellerInfo:any[]=[];
    addFirstValueTraveller(){
      var obj={};
      obj["dateOfBirth"]="";
      obj["age"]="";
      obj["arrivalDateOfCanada"]="";
      obj["waitPeroid"]="";
      this.travellerInfo.push(obj);
      this.numberOFInsured=1;
    }
    
    onClickQuestion1(data){
      if(data == "Yes"){
      this.innerPop=true;
      }else{
        for(let i=0;i<this.travellerInfo.length;i++){
          var Time = this.startDate.getTime() - this.travellerInfo[i].arrivalDateOfCanada.getTime(); 
          var Days = Time / (1000 * 3600 * 24); //Diference in Days 
          if(Days>=1 && Days <=30  && this.currentIndex == i){
            this.showarrivalDateInCanadaPopup=true;
            this.travellerInfo[i].waitPeroid="48 hours for a sickness. 24 hours for an Injury";
          }else if(Days>=30  && this.currentIndex == i){
            this.showarrivalDateInCanadaPopup=true;
            this.travellerInfo[i].waitPeroid="7 days for a Sickness, 24 hours for an injury";
          }
        }
      this.innerPop=false;
      }
      }
  
  
      onClickQuestion2(data){
        if(data == "Yes"){
          for(let i=0;i<this.travellerInfo.length;i++){
            var Time = this.startDate.getTime() - this.travellerInfo[i].arrivalDateOfCanada.getTime(); 
            var Days = Time / (1000 * 3600 * 24); //Diference in Days 
            if(Days>=1 && Days <=30  && this.currentIndex == i){
              this.showarrivalDateInCanadaPopup=true;
              this.travellerInfo[i].waitPeroid="None";
            }else if(Days>=30  && this.currentIndex == i){
              this.showarrivalDateInCanadaPopup=true;
              this.travellerInfo[i].waitPeroid="None";
            }
           
          }
          }else{
            for(let i=0;i<this.travellerInfo.length;i++){
              var Time = this.startDate.getTime() - this.travellerInfo[i].arrivalDateOfCanada.getTime(); 
              var Days = Time / (1000 * 3600 * 24); //Diference in Days 
              if(Days>=1 && Days <=30 && this.currentIndex == i){
                this.showarrivalDateInCanadaPopup=true;
                this.travellerInfo[i].waitPeroid="48 hours for a sickness. 24 hours for an Injury";
              }else if(Days>=30  && this.currentIndex == i){
                this.showarrivalDateInCanadaPopup=true;
                this.travellerInfo[i].waitPeroid="7 days for a Sickness, 24 hours for an injury";
              }
             
            }    }
      }
  
      selectedQuestionAns2: any;
  modalCloseQuestion(){
    this.showarrivalDateInCanadaPopup=false;
    this.selectedQuestionAns1=undefined;
    this.selectedQuestionAns2=undefined;  
    this.innerPop=false;
  }
  
  selectedQuestionprovince1: any;
  selectedQuestionlanguages1: any;
  planQuoteResponses=[];
  startDateShow=""
  expiryDateShow: any;
  resdentShowShow: any;
  daysToshow: any;
  travellerInformation=[];
  qestionInfoArray=[];
  postCallStep1(){
    var flag=true;
    if(!this.expiryDate){this.expiryDateFlag=true;flag=false}else{this.expiryDateFlag=false}
    if(!this.startDate){this.startDateFlag=true;flag=false}else{this.startDateFlag=false}
    if(!this.travellerInfo[0].arrivalDateOfCanada){this.arrivalDateCanadaFlag=true;flag=false}else{this.arrivalDateCanadaFlag=false}
    if(!this.travellerInfo[0].dateOfBirth){this.dobFlag=true;flag=false}else{this.dobFlag=false}
    if(!this.ageErrorCross){flag=false}else{}
     this.expiryDate = this.datePipe.transform(this.expiryDate, "yyyy-MM-dd");
     this.startDate = this.datePipe.transform(this.startDate, "yyyy-MM-dd");
    //  for(let i=0;i<this.travellerInfo.length;i++){
    //   this.travellerInfo[i].arrivalDateOfCanada = this.datePipe.transform(this.travellerInfo[i].arrivalDateOfCanada, "yyyy-MM-dd");
    //   this.travellerInfo[i].dateOfBirth = this.datePipe.transform(this.travellerInfo[i].dateOfBirth, "yyyy-MM-dd");
    //  }
      if (flag == true) {
    
        const request = 
        {
      "agentId": this.agentId,
      "declaration": true,
      "deductableOptions": [
        {
          "amount": 0,
          "createdAt": "2022-04-27T05:08:15.125Z",
          "createdBy": "string",
          "id": 0,
          "lastModifiedBy": "string",
          "option": "string",
          "reduceAmount": 0,
          "updatedAt": "2022-04-27T05:08:15.125Z"
        }
      ],
      "language": this.selectedQuestionlanguages1,
      "noOfDays": this.calculatedDays,
      "optionalInformation": {
        "agentNote": "string",
        "beneficiary": "string",
        "comment": "string"
      },
      "paymentInformation": {
        "amount": 0,
        "cardNumber": "string",
        "cardType": "string",
        "cvv": "string",
        "expiryDate": "string"
      },
      "primaryAddress": {
        "address1": "string",
        "address2": "string",
        "city": "string",
        "postalCode": "string",
        "province":"string"
      },
      "purchaserAddressSame": true,
      "questionsansers": [
     
      ],
      "residentOf": this.selectedQuestionprovince1,
      "returnDate": this.expiryDate,
      "secondaryAddress": {
        "address1": "string",
        "address2": "string",
        "city": "string",
        "postalCode": "string",
        "province":"string"
      },
      "selectedPlan": {},
      "startDate": this.startDate,
      "travellerInformation": this.travellerInfo,
      "travelllerDetails": [
        {
          "arrivalDateInCanada": "",
          "country": "",
          "dateOfBirth": "",
          "dayTimePhone": "",
          "departureCity": "",
          "emailAddress": "",
          "firstName": "",
          "insitute": "",
          "language": "",
          "lastName": ""
        }
      ],
      "visitorsToCanada": "yes",
      "purchaserInformation":{
        "country": "",
        "emailAddress": "",
        "firstName": "",
        "language": "",
        "lastName": "",
        "phoneNumber1": "",
        "phoneNumber2": "",
        "postalCode": "",
        "province": "",
        "purchaserAddress": {
          "address1": "",
          "address2": "",
          "city": "",
          "postalCode": ""
      }}
         }
        this.base.callPostService(this.config.postApistep1, request).subscribe((data: any) => {
        this.onClickToShowPlanInfo();
        this.planQuoteResponses = data.data.planQuoteResponses;
        this.startDateShow = data.data.salesRequest.startDate;
        this.expiryDateShow=data.data.salesRequest.returnDate;
        this.resdentShowShow=data.data.salesRequest.residentOf;
        this.daysToshow = this.calculatedDays;
        this.travellerInformation = data.data.salesRequest.travellerInformation;
        this.qestionInfoArray = data.data.questions;
        this.qestionInfoArrayShow.push(this.qestionInfoArray[0]);
           }, error => {
      
        }, () => { });
    }}
    qestionInfoArrayShow=[];
  
    onClickToShowPlanInfo(){
      
      window.scrollTo(0,0);
    var flag=true;
    if(!this.expiryDate){this.expiryDateFlag=true;flag=false}else{this.expiryDateFlag=false}
    if(!this.startDate){this.startDateFlag=true;flag=false}else{this.startDateFlag=false}
    if(!this.travellerInfo[0].arrivalDateOfCanada){this.arrivalDateCanadaFlag=true;flag=false}else{this.arrivalDateCanadaFlag=false}
    if(!this.travellerInfo[0].dateOfBirth){this.dobFlag=true;flag=false}else{this.dobFlag=false}
     this.expiryDate = this.datePipe.transform(this.expiryDate, "yyyy-MM-dd");
     this.startDate = this.datePipe.transform(this.startDate, "yyyy-MM-dd");
     this.step2SaveApiCall()
    //  for(let i=0;i<this.travellerInfo.length;i++){
    //   this.travellerInfo[i].arrivalDateOfCanada = this.datePipe.transform(this.travellerInfo[i].arrivalDateOfCanada, "yyyy-MM-dd");
    //   this.travellerInfo[i].dateOfBirth = this.datePipe.transform(this.travellerInfo[i].dateOfBirth, "yyyy-MM-dd");
    //  }
    
      if (flag == true) {
        const request = 
        {
       "agentId": this.agentId,
       "declaration": true,
       "deductableOptions": [
        {
          "amount": 0,
          "createdAt": "2022-04-27T05:08:15.125Z",
          "createdBy": "string",
          "id": 0,
          "lastModifiedBy": "string",
          "option": "string",
          "reduceAmount": 0,
          "updatedAt": "2022-04-27T05:08:15.125Z"
        }
       ],
       "language": this.selectedQuestionlanguages1,
       "noOfDays": this.calculatedDays,
       "optionalInformation": {
        "agentNote": "string",
        "beneficiary": "string",
        "comment": "string"
       },
       "paymentInformation": {
        "amount": 0,
        "cardNumber": "string",
        "cardType": "string",
        "cvv": "string",
        "expiryDate": "string"
       },
       "primaryAddress": {
        "address1": "string",
        "address2": "string",
        "city": "string",
        "postalCode": "string",
        "province":"string"
       },
       "purchaserAddressSame": true,
       "questionsansers": [
       
       ],
       "residentOf": this.selectedQuestionprovince1,
       "returnDate": this.expiryDate,
       "secondaryAddress": {
        "address1": "string",
        "address2": "string",
        "city": "string",
        "postalCode": "string",
        "province":"string"
       },
       "selectedPlan": {},
       "startDate": this.startDate,
       "travellerInformation": this.travellerInfo,
       "travelllerDetails": [
        {
          "arrivalDateInCanada": "",
          "country": "",
          "dateOfBirth": "",
          "dayTimePhone": "",
          "departureCity": "",
          "emailAddress": "",
          "firstName": "",
          "insitute": "",
          "language": "",
          "lastName": ""
        }
       ],
       "visitorsToCanada": "yes",
       "purchaserInformation":{
        "country": "",
        "emailAddress": "",
        "firstName": "",
        "language": "",
        "lastName": "",
        "phoneNumber1": "",
        "phoneNumber2": "",
        "postalCode": "",
        "province": "",
        "purchaserAddress": {
          "address1": "",
          "address2": "",
          "city": "",
          "postalCode": ""
       }}
         }
       
        this.base.callPostService(this.config.postApistep1, request).subscribe((data: any) => {
        this.planQuoteResponses = data.data.planQuoteResponses;
        this.startDateShow=data.data.salesRequest.startDate;
        this.expiryDateShow=data.data.salesRequest.returnDate;
        this.resdentShowShow=data.data.salesRequest.residentOf;
        this.daysToshow = this.calculatedDays;
        this.travellerInformation = data.data.salesRequest.travellerInformation;
        // for(let i=0;i<data.data.salesRequest.travellerInformation.length;i++){
        //   var obj={}
        //   obj["age"]=data.data.salesRequest.travellerInformation[i].age
        //   obj["arrivalDateOfCanada"]=data.data.salesRequest.travellerInformation[i].arrivalDateOfCanada
        //   obj["dateOfBirth"]=data.data.salesRequest.travellerInformation[i].dateOfBirth
        //   obj["waitPeroid"]=data.data.salesRequest.travellerInformation[i].waitPeroid
        //   obj["checkToggleButtonYesbtn"]="Active1"
        //   obj["checkToggleButtonNobtn"]="Active1"
        //   this.travellerInformation.push(obj)
        // }
        this.qestionInfoArray = data.data.questions;
        this.qestionInfoArrayShow=[];
        this.qestionInfoArrayShow.push(this.qestionInfoArray[0]);
        window.scrollTo(0, 0);
        this.showChangePolicy=true;
        this.showChangePolicyStepOne=false;
        this.showChangePolicyStepTwo=true;
        //this.showChangePolicyStepTwoB=true;
         this.showChangePolicyStepThree=false;
         this.showChangePolicyStepThreeAdminFee=false;
        //this.showChangePolicyStepThreeAdminFee=true;  //new
        this.showChangePolicyStepFour=false;
        this.showChangePolicyStepFive=false;
        this.showSearchedPolicy=false;
        this.showPolicyDetails=false;
        this.showPolicySearch=false;
        this.showRefundPolicy=false;
        this.showAudtiLogs=false;
        // this.showChooseQuote=false;
        // this.showIntStudPlan=true;
        // this.showIntStudPlanStep1=false;
        // this.showIntStudPlanPlanOption=true;
        // this.showQuestionnaire=false;
        // this.showContactInfo=false;
        // this.showPayment=false;
        // this.showPaymentsDetails=false;
           }, error => {
             
        }, () => { });
    }
       }
  
  
    showChangePolicy:boolean=false;
    showChangePolicyStepOne:boolean=false;
    showChangePolicyStepTwo:boolean=false;
    showChangePolicyStepTwoB:boolean=false;
    showChangePolicyStepThree:boolean=false;
    showChangePolicyStepThreeAdminFee:boolean=false;
    showChangePolicyStepFour:boolean=false;
    showChangePolicyStepFive:boolean=false;
    onClickChangePolicy(){
      // window.scrollTo(0, 0);
      // this.showChangePolicy=true;
      // this.showChangePolicyStepOne=true;
      // this.showChangePolicyStepTwo=false;
      // this.showChangePolicyStepTwoB=false;
      // this.showChangePolicyStepThree=false;
      // this.showChangePolicyStepThreeAdminFee=false;
      // this.showChangePolicyStepFour=false;
      // this.showChangePolicyStepFive=false;
      // this.showSearchedPolicy=false;
      // this.showPolicyDetails=false;
      // this.showPolicySearch=false;
      // this.showRefundPolicy=false;
      // this.showAudtiLogs=false;
      this.router.navigateByUrl('/dashboard/change-policy');
    }
    onClickChangePolicyStepOneNext(){
      window.scrollTo(0, 0);
      this.showChangePolicy=true;
      this.showChangePolicyStepOne=false;
      this.showChangePolicyStepTwo=true;
      this.showChangePolicyStepTwoB=false;
      this.showChangePolicyStepThree=false;
      this.showChangePolicyStepThreeAdminFee=false;
      this.showChangePolicyStepFour=false;
      this.showChangePolicyStepFive=false;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=false;
      this.showPolicySearch=false;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
      var flag=true;
  if(!this.expiryDate){this.expiryDateFlag=true;flag=false}else{this.expiryDateFlag=false}
  if(!this.startDate){this.startDateFlag=true;flag=false}else{this.startDateFlag=false}
  if(!this.travellerInfo[0].arrivalDateOfCanada){this.arrivalDateCanadaFlag=true;flag=false}else{this.arrivalDateCanadaFlag=false}
  if(!this.travellerInfo[0].dateOfBirth){this.dobFlag=true;flag=false}else{this.dobFlag=false}
   this.expiryDate = this.datePipe.transform(this.expiryDate, "yyyy-MM-dd");
   this.startDate = this.datePipe.transform(this.startDate, "yyyy-MM-dd");
  
    }
    purchaserAddress2: any;
    firstNameFlag: boolean=false;
    lastNameFlag: boolean=false;
    InstituteFlag: boolean=false;
    CountryFlag: boolean=false;
    
    removeFirstNameError(){
      this.firstNameFlag=false;
    }
    removeLastNameError(){
     this.lastNameFlag=false;
   }
   removeInstituteNameError(){
     this.InstituteFlag=false;
   }
   removeCountryNameError(){
     this.CountryFlag=false;
   }
  
   countryListing: any=[];
  getcountryListing(){
    this.user.getCountryDropdown().subscribe((data:any) =>{
     this.countryListing = data.data;
    },error=>{{
    //handle Exception from Server 404,401
    }},()=>{});
  }
  
  
    onClickChangePolicyStepOneBack(){
      window.scrollTo(0, 0);
      this.showChangePolicy=false;
      this.showChangePolicyStepOne=false;
      this.showChangePolicyStepTwo=false;
      this.showChangePolicyStepTwoB=false;
      this.showChangePolicyStepThree=false;
      this.showChangePolicyStepThreeAdminFee=false;
      this.showChangePolicyStepFour=false;
      this.showChangePolicyStepFive=false;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=true;
      this.showPolicySearch=false;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
    }
    onClickChangePolicyStepTwoNext(){
      window.scrollTo(0, 0);
      this.showChangePolicy=true;
      this.showChangePolicyStepOne=false;
      this.showChangePolicyStepTwo=true;
      this.showChangePolicyStepTwoB=false;
      this.showChangePolicyStepThree=true;
      this.showChangePolicyStepThreeAdminFee=false;
      this.showChangePolicyStepFour=false;
      this.showChangePolicyStepFive=false;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=false;
      this.showPolicySearch=false;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
    }
    onClickChangePolicyStepTwoBack(){
      window.scrollTo(0, 0);
      this.showChangePolicy=true;
      this.showChangePolicyStepOne=true;
      this.showChangePolicyStepTwo=false;
      this.showChangePolicyStepTwoB=false;
      this.showChangePolicyStepThree=false;
      this.showChangePolicyStepThreeAdminFee=false;
      this.showChangePolicyStepFour=false;
      this.showChangePolicyStepFive=false;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=false;
      this.showPolicySearch=false;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
    }
    onClickChangePolicyStepTwoBNext(){
      window.scrollTo(0, 0);
      this.showChangePolicy=true;
      this.showChangePolicyStepOne=false;
      this.showChangePolicyStepTwo=false;
      this.showChangePolicyStepTwoB=false;
      this.showChangePolicyStepThree=true;
      //this.showChangePolicyStepThreeAdminFee=false;
      this.showChangePolicyStepThreeAdminFee=true   //new line added
      this.showChangePolicyStepFour=false;
      this.showChangePolicyStepFive=false;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=false;
      this.showPolicySearch=false;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
    }
    onClickChangePolicyStepTwoBBack(){
      window.scrollTo(0, 0);
      this.showChangePolicy=true;
      this.showChangePolicyStepOne=false;
      this.showChangePolicyStepTwo=true;
      this.showChangePolicyStepTwoB=false;
      //this.showChangePolicyStepTwoB=true;       //new line
      this.showChangePolicyStepThree=false;
      this.showChangePolicyStepThreeAdminFee=false;
      //this.showChangePolicyStepThreeAdminFee=true;
      this.showChangePolicyStepFour=false;
      this.showChangePolicyStepFive=false;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=false;
      this.showPolicySearch=false;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
    }
    onClickChangePolicyStepThreeNext(){
      window.scrollTo(0, 0);
      this.showChangePolicy=true;
      this.showChangePolicyStepOne=false;
      this.showChangePolicyStepTwo=false;
      this.showChangePolicyStepTwoB=false;
      this.showChangePolicyStepThree=false;
      this.showChangePolicyStepThreeAdminFee=true;
      this.showChangePolicyStepFour=false;
      this.showChangePolicyStepFive=false;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=false;
      this.showPolicySearch=false;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
    }
    // onClickChangePolicyStepThreeBack(){
    //   window.scrollTo(0, 0);
    //   this.showChangePolicy=true;
    //   this.showChangePolicyStepOne=false;
    //   this.showChangePolicyStepTwo=false;
    //   this.showChangePolicyStepTwoB=true;
    //   this.showChangePolicyStepThree=false;
    //   this.showChangePolicyStepThreeAdminFee=false;
    //   this.showChangePolicyStepFour=false;
    //   this.showChangePolicyStepFive=false;
    //   this.showSearchedPolicy=false;
    //   this.showPolicyDetails=false;
    //   this.showPolicySearch=false;
    //   this.showRefundPolicy=false;
    // }
    onClickChangePolicyStepThreeBack(){
      window.scrollTo(0, 0);
      this.showChangePolicy=true;
      this.showChangePolicyStepOne=false;
      this.showChangePolicyStepTwo=false;
      this.showChangePolicyStepTwoB=false;
      this.showChangePolicyStepThree=true;
      this.showChangePolicyStepThreeAdminFee=false;
      this.showChangePolicyStepFour=false;
      this.showChangePolicyStepFive=false;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=false;
      this.showPolicySearch=false;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
    }
    onClickChangePolicyStepThreeAdminTreeNext(){
      window.scrollTo(0, 0);
      this.showChangePolicy=true;
      this.showChangePolicyStepOne=false;
      this.showChangePolicyStepTwo=false;
      this.showChangePolicyStepTwoB=false;
      this.showChangePolicyStepThree=false;
      this.showChangePolicyStepThreeAdminFee=false;
      this.showChangePolicyStepFour=true;
      this.showChangePolicyStepFive=false;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=false;
      this.showPolicySearch=false;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
    }
    onClickChangePolicyStepThreeAdminTreeBack(){
      window.scrollTo(0, 0);
      this.showChangePolicy=true;
      this.showChangePolicyStepOne=false;
      this.showChangePolicyStepTwo=true;
      //this.showChangePolicyStepTwoB=false;
      //this.showChangePolicyStepTwoB=true;     //new 
      this.showChangePolicyStepThree=false;
      this.showChangePolicyStepThreeAdminFee=false;
      this.showChangePolicyStepFour=false;
      this.showChangePolicyStepFive=false;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=false;
      this.showPolicySearch=false;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
    }
    onClickChangePolicyStepFourNext(){
      window.scrollTo(0, 0);
      this.showChangePolicy=true;
      this.showChangePolicyStepOne=false;
      this.showChangePolicyStepTwo=false;
      this.showChangePolicyStepTwoB=false;
      this.showChangePolicyStepThree=false;
      this.showChangePolicyStepThreeAdminFee=false;
      this.showChangePolicyStepFour=false;
      this.showChangePolicyStepFive=true;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=false;
      this.showPolicySearch=false;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
    }
    onClickChangePolicyStepFourBack(){
      window.scrollTo(0, 0);
      this.showChangePolicy=true;
      this.showChangePolicyStepOne=false;
      this.showChangePolicyStepTwo=false;
      this.showChangePolicyStepTwoB=false;
      this.showChangePolicyStepThree=false;
      this.showChangePolicyStepThreeAdminFee=true;
      this.showChangePolicyStepFour=false;
      this.showChangePolicyStepFive=false;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=false;
      this.showPolicySearch=false;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
    }
    onClickChangePolicyStepFiveNext(){
      window.scrollTo(0, 0);
      Swal.fire('',"Successfully Sent",'success')
      this.showChangePolicy=false;
      this.showChangePolicyStepOne=false;
      this.showChangePolicyStepTwo=false;
      this.showChangePolicyStepTwoB=false;
      this.showChangePolicyStepThree=false;
      this.showChangePolicyStepThreeAdminFee=false;
      this.showChangePolicyStepFour=false;
      this.showChangePolicyStepFive=false;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=true;
      this.showPolicySearch=false;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
    }
    onClickChangePolicyStepFiveBack(){
      window.scrollTo(0, 0);
      this.showChangePolicy=true;
      this.showChangePolicyStepOne=false;
      this.showChangePolicyStepTwo=false;
      this.showChangePolicyStepTwoB=false;
      this.showChangePolicyStepThree=false;
      this.showChangePolicyStepThreeAdminFee=false;
      this.showChangePolicyStepFour=true;
      this.showChangePolicyStepFive=false;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=false;
      this.showPolicySearch=false;
      this.showRefundPolicy=false;
      this.showAudtiLogs=false;
    }
    showPaymentHistoryPopup:boolean=false;
    showEditBillingInformation:boolean=false;
    onClickEditBillingInfo(){
      this.editBilling(this.policyIDDetail[0].creditCardDetails)
      this.showEditBillingInformation=true;
      this.showSearchedPolicy=false;
      this.showPolicyDetails=false;
      this.showPolicySearch=false;
      this.showAudtiLogs=false;
      this.showRefundPolicy=false;
      this.showChangePolicy=false;
    }
    backToPolicyDetails(){
      // this.showEditBillingInformation=false;
      // this.showSearchedPolicy=false;
      // this.showPolicyDetails=true;
      // this.showPolicySearch=false;
      // this.showRefundPolicy=false;
      // this.showAudtiLogs=false;
      // this.showChangePolicy=false;
      localStorage.setItem('tlSalesAdminPolicyAdmin',this.policyId)
      this.router.navigateByUrl('/dashboard/policy-details');
    }
    userPolicyDetails=[];
    policyTotal:any;
    onSelectSizePage:any=30;
    p:any=0;
    policyPageNo:any=0;
    getAllPolicyForSalesAdmin(){
      this.userservice.getAllPolicyForSalesAdmin().pipe()
      .subscribe(
          data => {
            if(data.data.userPolicyDetails.length!=0){
              this.userPolicyDetails=data.data.userPolicyDetails;
              this.policyTotal=data.data.total;
            }
          },error=>{},()=>{});
    }
    pageChnageDone(data){
      this.policyPageNo = data-1;
      this.userservice.getAllPolicyForSalesAdminByPage(this.policyPageNo,this.onSelectSizePage).pipe()
      .subscribe(
          data => {
            if(data.data.userPolicyDetails.length!=0){
              this.userPolicyDetails=data.data.userPolicyDetails;
              this.policyTotal=data.data.total;
            }
      },error=>{},()=>{});
    }
    onPolicySortAsc(data){
      this.userservice.getAllPolicyForSalesAdminSortAsc(this.policyPageNo,this.onSelectSizePage,data).pipe()
      .subscribe(
          data => {
            if(data.data.userPolicyDetails.length!=0){
              this.userPolicyDetails=data.data.userPolicyDetails;
              this.policyTotal=data.data.total;
            }
          },error=>{},()=>{});
    }
    onPolicySortDsc(data){
      this.userservice.getAllPolicyForSalesAdminSortDesc(this.policyPageNo,this.onSelectSizePage,data).pipe()
      .subscribe(
          data => {
            if(data.data.userPolicyDetails.length!=0){
              this.userPolicyDetails=data.data.userPolicyDetails;
              this.policyTotal=data.data.total;
            }
          },error=>{},()=>{});
    }
    policyIDDetail=[]
    policyStatus:any;
    getPolicyByIdSalesAdmin(){
      this.userservice.getPolicyByIdSalesAdmin(this.policyId).pipe()
      .subscribe(
        data => {
          
          this.ssl_card_number=data.data.transactions[0].transactionPaymentDetails[0].sslCardNumber
          this.policyIDDetail=[];
          this.policyIDDetail.push(data.data);
          this.policyNumber=data.data.policyNumber;
          this.txnId = data.data.transactions[0].transactionPaymentDetails[0].sslTxnId;
          this.Amount = data.data.policyPremium
          this.PrevAmount = data.data.policyPremium
         
          this.purchasePostalCode=data.data.purchaserAddressPostalCode;
            
          this.purchaserAddress1=data.data.purchaserAddress1;
          this.ssl_card_type = data.data.transactions[0].transactionPaymentDetails[0].sslCardType
          this.ssl_exp_date = data.data.transactions[0].transactionPaymentDetails[0].sslExpDate
          this.ssl_cvv2_response = data.data.transactions[0].transactionPaymentDetails[0].sslCvv2Response
          this.policyStatus=data.data.status.status
          this.creditCardDetails = data.data.creditCardDetails;
          this.policypaymentdetailsArray=[]
          for(let k=0;k<data.data.transactions.length;k++){
            if(data.data.transactions[k].transactionPaymentDetails[0].sslTransactionType!="RETURN"){
            this.policypaymentdetailsArray.push(data.data.transactions[k])
          }
          }
          this.policypaymentdetailsArray1=[]
          for(let k=0;k<data.data.transactions.length;k++){
            
            this.policypaymentdetailsArray1.push(data.data.transactions[k])
  
          }
      },error=>{},()=>{});
    }
    onClickPolicyNumber1(){
      // this.showPolicyDetails=true;
      // this.showPolicySearch=false;
      // this.showRefundPolicy=false;
      // this.showAudtiLogs=false;
    }
  
    showReasonError: boolean=false;
    removeRefundError(){
      this.showReasonError=false;
    }
  
    onRefundProcessCall(){
  
      var flag = true;
   
      
          if(!this.adminFee || this.adminFee==""){flag=false;this.adminfeeerror=true}else{this.adminfeeerror=false}
           if(!this.adminFeeReason || this.adminFeeReason=="")
           {flag=false;this.adminFeeReasonerror=true}
           else{this.adminFeeReasonerror=false}
      // if(!this.refundPolicyReason)
      // {this.showReasonError=true;flag=false}
      
      // else{
       if(flag==true){
      Swal.fire({
        // title: 'Are you sure?',
        text: "Are you sure you want to process this refund?",
        // icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2778c4 !important;',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes'
      }).then((result) => {
        if (result.isConfirmed) {
          
          var convertAmount = this.Amount;
          if(this.Amount!=null && convertAmount.charAt(0) == '$'){
          while(convertAmount.charAt(0) === '$')
             {
              convertAmount = convertAmount.substring(1);
             }
             
             convertAmount=convertAmount.replace (/,/g, "");
            }
  
            this.Amount=convertAmount
          var convertPrevAmount = this.PrevAmount;
          if(this.PrevAmount!=null && convertPrevAmount.charAt(0) == '$'){
          while(convertPrevAmount.charAt(0) === '$')
             {
              convertPrevAmount = convertPrevAmount.substring(1);
             }
             
             convertPrevAmount=convertPrevAmount.replace (/,/g, "");
            }
  
            this.PrevAmount=convertPrevAmount
           var convertAmount2 = this.Amount2
          if(this.Amount2!=null  && convertAmount2.charAt(0) == '$'){
          while(convertAmount2.charAt(0) === '$')
             {
              convertAmount2 = convertAmount2.substring(1);
             }
             
             convertAmount2=convertAmount2.replace (/,/g, "");
            }
            this.Amount2=convertAmount2
            var convertAmount3=this.Amount3
            if(this.Amount3!=null && convertAmount3.charAt(0) == '$'){
          while(convertAmount3.charAt(0) === '$')
             {
              convertAmount3 = convertAmount3.substring(1);
             }
             
             convertAmount3=convertAmount3.replace (/,/g, "");
            }
            this.Amount3=convertAmount3
            var convertAmount4=this.Amount4
            if(this.Amount4!=null && convertAmount4.charAt(0) == '$'){
          while(convertAmount4.charAt(0) === '$')
             {
              convertAmount4 = convertAmount4.substring(1);
             }
             
             convertAmount4=convertAmount4.replace (/,/g, "");
            }
            this.Amount4=convertAmount4
            var convertAmount5=this.Amount5
            if(this.Amount5!=null && convertAmount5.charAt(0) == '$'){
          while(convertAmount5.charAt(0) === '$')
             {
              convertAmount5 = convertAmount5.substring(1);
             }
             
             convertAmount5=convertAmount5.replace (/,/g, "");
            }
            this.Amount5=convertAmount5
        if(this.Amount!=null && this.ssl_card_type !=null && this.ssl_card_number!==null && this.ssl_exp_date!=null){
        //  if(this.Amount<0){
        
        //     while(this.Amount.charAt(0) === '-')
        //        {
        //         this.Amount = this.Amount.substring(1);
        //        }
        //   this.cardInfo=[]
        //   if(this.cardType1 !==this.ssl_card_number){
        //     var obj9={}
        //     obj9["cardNumber"]= this.CardNumber1;
        //     obj9["cvvNumber"]= this.cvv1;
        //     obj9["expiryDate"]= this.cardexpdate1;
        //     obj9["purchaserAddressPostalCode"]= this.purchasePostalCode;
        //     obj9["purchaserAddressStreet"]= this.purchaserAddress1;
        //     this.cardInfo.push(obj9)
        //   }
        //  }
        //  else{
          this.cardInfo=null;
          if(this.cardType1 !==this.ssl_card_number){
          if(this.cardType1 !==undefined &&this.CardNumber1!==undefined && this.cardexpdate1 !==undefined){
          
            var obj9={}
            obj9["cardNumber"]= this.CardNumber1;
           //  obj9["cvvNumber"]= this.cvv1;
            obj9["expiryDate"]= this.cardexpdate1;
            obj9["purchaserAddressPostalCode"]= this.purchasePostalCode;
            obj9["purchaserAddressStreet"]= this.purchaserAddress1;
            this.cardInfo=(obj9)
          }
        
        else{
                flag=false
                Swal.fire('',"Please check payment details",'error')
              }
            }
          this.AmounttoPay=this.Amount
          this.ssl_card_type1=this.ssl_card_type
          this.ssl_card_number1=this.ssl_card_number
          this.ssl_exp_date1=this.ssl_exp_date
          // this.ssl_cvv2_response1=this.ssl_cvv2_response
        // }
      
      
        }
        else if(this.Amount2!=null && this.cardType2 !=null && this.CardNumber2!==null && this.cardexpdate2!=null ){
          // if(this.Amount2<0){
          //   while(this.Amount2.charAt(0) === '-')
          //      {
          //       this.Amount2 = this.Amount2.substring(1);
          //      }
          //      this.cardInfo=[]
          //      if(this.cardType2 !==this.ssl_card_number){
          //        var obj9={}
          //        obj9["cardNumber"]= this.CardNumber2;
          //       //  obj9["cvvNumber"]= this.cvv1;
          //        obj9["expiryDate"]= this.cardexpdate2;
          //        obj9["purchaserAddressPostalCode"]= this.purchasePostalCode;
          //        obj9["purchaserAddressStreet"]= this.purchaserAddress1;
          //        this.cardInfo.push(obj9)
          //      }
          //  }
          //  else{
            this.cardInfo=null;
            if(this.cardType2 !==this.ssl_card_number){
            if(this.cardType2 !==undefined &&this.CardNumber2!==undefined && this.cardexpdate2 !==undefined){
            
              var obj9={}
              obj9["cardNumber"]= this.CardNumber2;
             //  obj9["cvvNumber"]= this.cvv1;
              obj9["expiryDate"]= this.cardexpdate2;
              obj9["purchaserAddressPostalCode"]= this.purchasePostalCode;
              obj9["purchaserAddressStreet"]= this.purchaserAddress1;
              this.cardInfo=(obj9)
            }
            else{
              flag=false
              Swal.fire('',"Please check payment details",'error')
            }
          }
          this.AmounttoPay=this.Amount2
          this.ssl_card_type1=this.cardType2
          this.ssl_card_number1=this.CardNumber2
          this.ssl_exp_date1=this.cardexpdate2
          // this.ssl_cvv2_response1=this.cvv2
        //  }
     
        }
        else if(this.Amount3!=null && this.cardType3 !=null && this.CardNumber3!==null && this.cardexpdate3!=null ){
          // if(this.Amount3<0){
          //   while(this.Amount3.charAt(0) === '-')
          //      {
          //       this.Amount3 = this.Amount3.substring(1);
          //      }
          //      this.cardInfo=[]
          //      if(this.cardType3 !==this.ssl_card_number){
          //        var obj9={}
          //        obj9["cardNumber"]= this.CardNumber3;
          //       //  obj9["cvvNumber"]= this.cvv1;
          //        obj9["expiryDate"]= this.cardexpdate3;
          //        obj9["purchaserAddressPostalCode"]= this.purchasePostalCode;
          //        obj9["purchaserAddressStreet"]= this.purchaserAddress1;
          //        this.cardInfo.push(obj9)
          //      }
          //  }
          //  else{
            this.cardInfo=null;
            if(this.cardType3 !==this.ssl_card_number){
            if(this.cardType3 !==undefined &&this.CardNumber3!==undefined && this.cardexpdate3 !==undefined){
            
              var obj9={}
              obj9["cardNumber"]= this.CardNumber3;
             //  obj9["cvvNumber"]= this.cvv1;
              obj9["expiryDate"]= this.cardexpdate3;
              obj9["purchaserAddressPostalCode"]= this.purchasePostalCode;
              obj9["purchaserAddressStreet"]= this.purchaserAddress1;
              this.cardInfo=(obj9)
            }
            else{
              flag=false
              Swal.fire('',"Please check payment details",'error')
            }
          }
          this.AmounttoPay=this.Amount3
          this.ssl_card_type1=this.cardType3
          this.ssl_card_number1=this.CardNumber3
          this.ssl_exp_date1=this.cardexpdate3
          // this.ssl_cvv2_response1=this.cvv3
            // }
         
        }
        else if(this.Amount4!=null && this.cardType4 !=null && this.CardNumber4!==null && this.cardexpdate4!=null){
          // if(this.Amount4<0){
          //   while(this.Amount4.charAt(0) === '-')
          //   {
          //    this.Amount4 = this.Amount4.substring(1);
          //   }
          //   this.cardInfo=[]
          //   if(this.cardType4 !==this.ssl_card_number){
          //     var obj9={}
          //     obj9["cardNumber"]= this.CardNumber4;
          //    //  obj9["cvvNumber"]= this.cvv1;
          //     obj9["expiryDate"]= this.cardexpdate4;
          //     obj9["purchaserAddressPostalCode"]= this.purchasePostalCode;
          //     obj9["purchaserAddressStreet"]= this.purchaserAddress1;
          //     this.cardInfo.push(obj9)
          //   }
          //  }
          //  else{
            this.cardInfo=null;
            if(this.cardType4 !==this.ssl_card_number){
            if(this.cardType4 !==undefined &&this.CardNumber4!==undefined && this.cardexpdate4 !==undefined){
           
              var obj9={}
              obj9["cardNumber"]= this.CardNumber4;
             //  obj9["cvvNumber"]= this.cvv1;
              obj9["expiryDate"]= this.cardexpdate4;
              obj9["purchaserAddressPostalCode"]= this.purchasePostalCode;
              obj9["purchaserAddressStreet"]= this.purchaserAddress1;
              this.cardInfo=(obj9)
            }
            else{
              flag=false
              Swal.fire('',"Please check payment details",'error')
            }
          }
          this.AmounttoPay=this.Amount4
          this.ssl_card_type1=this.cardType4
          this.ssl_card_number1=this.CardNumber4
          this.ssl_exp_date1=this.cardexpdate4
          // this.ssl_cvv2_response1=this.cvv4
            // }
         
        }
        else if(this.Amount5!=null && this.cardType5 !=null && this.CardNumber5!==null && this.cardexpdate5!=null ){
          // if(this.Amount5<0){
          //   while(this.Amount5.charAt(0) === '-')
          //   {
          //    this.Amount5 = this.Amount5.substring(1);
          //   }
          //   this.cardInfo=[]
          //   if(this.cardType5 !==this.ssl_card_number){
          //     var obj9={}
          //     obj9["cardNumber"]= this.CardNumber5;
          //    //  obj9["cvvNumber"]= this.cvv1;
          //     obj9["expiryDate"]= this.cardexpdate5;
          //     obj9["purchaserAddressPostalCode"]= this.purchasePostalCode;
          //     obj9["purchaserAddressStreet"]= this.purchaserAddress1;
          //     this.cardInfo.push(obj9)
          //   }
          //  }
          //  else{
            this.cardInfo=null;
            if(this.cardType5 !==this.ssl_card_number){
            if(this.cardType5 !==undefined &&this.CardNumber5!==undefined && this.cardexpdate5 !==undefined){
           
              var obj9={}
              obj9["cardNumber"]= this.CardNumber5;
             //  obj9["cvvNumber"]= this.cvv1;
              obj9["expiryDate"]= this.cardexpdate5;
              obj9["purchaserAddressPostalCode"]= this.purchasePostalCode;
              obj9["purchaserAddressStreet"]= this.purchaserAddress1;
              this.cardInfo=(obj9)
            }
            else{
              flag=false
              Swal.fire('',"Please check payment details",'error')
            }
          }
          this.AmounttoPay=this.Amount5
          this.ssl_card_type1=this.cardType5
          this.ssl_card_number1=this.CardNumber5
          this.ssl_exp_date1=this.cardexpdate5
          // this.ssl_cvv2_response1=this.cvv5
            // }
        
        }
  
          if(flag==true){
            // this.adminFee=0
            // this.PrevAmount=1
            this.userservice.refundCallApi(this.adminFee,this.Amount,this.PrevAmount,this.policyId,this.paymentTokenNew,this.adminFeeReason,this.cardInfo).pipe()
            .subscribe(
                data => {
                  if(data.status==true){
                  Swal.fire('',data.message,'success');
                  setTimeout(() =>
                  {
                    this.router.navigateByUrl('/dashboard/policy-details');
                  },
                 1000);
                }
                else{
                  // this.loading=false;
                  // this.blockUI.stop();
                  Swal.fire('',data.message,'error')
                
                 }
                },error=>{},()=>{});
          }
        }
      })
    }
      // var flag = true;
      // if(!this.refundPolicyReason){this.showReasonError=true;flag=false}else{this.showReasonError=false;flag=true}
      // if(flag){
      //   this.userservice.refundCallApi(this.policyId,this.txnId,this.refundPolicyReason).pipe()
      //   .subscribe(
      //       data => {
      //         Swal.fire('',data.message,'success');
      //       },error=>{},()=>{});
      // }
    }
  
    searchFilterPolicy(){
    this.effectiveStartDate = this.datePipe.transform(this.effectiveStartDate, "yyyy-MM-dd");
    this.departureStartDate = this.datePipe.transform(this.departureStartDate, "yyyy-MM-dd");
    this.applicationStartDate = this.datePipe.transform(this.applicationStartDate, "yyyy-MM-dd");
    this.applicationEndDate = this.datePipe.transform(this.applicationEndDate, "yyyy-MM-dd");
    
      this.userservice.getFilterSearchPolicy(this.agencyCode,this.policyNumber,this.lastName,this.firstName,this.effectiveStartDate,this.departureStartDate,this.departureEndDate,this.creditCardNumber,this.applicationStartDate,this.applicationEndDate).pipe()
        .subscribe(
            data => {
              if(data.data.searchPolicyDetails.length!=0){
                this.userPolicyDetails=[]
                this.userPolicyDetails=data.data.searchPolicyDetails;
                this.policyTotal=data.data.total;
              }
            },error=>{},()=>{});
      }
      viewCOC(){
        this.userservice.viewCOC(this.policyId).pipe()
        .subscribe(
            data => {
              
              var url=data.data
               var win = window.open(url, '_blank');
            },error=>{},()=>{});
      }
      editBilling(creditCardDetails){
        
        var cardType=creditCardDetails[0].cardType
        var id=creditCardDetails[0].id
        var sslCardNumber=creditCardDetails[0].sslCardNumber
        var sslCardShortDescription=creditCardDetails[0].sslCardShortDescription
        var sslCardType=creditCardDetails[0].sslCardType
        var sslCvv2Response=creditCardDetails[0].sslCvv2Response
        var sslExpDate=creditCardDetails[0].sslExpDate
        var sslTransactionType=creditCardDetails[0].sslTransactionType
        // cardType,id,policyId,sslCardNumber,sslCardShortDescription,sslCardType,sslCvv2Response,sslExpDate,sslTransactionType
        this.userservice.editBilling(cardType,id,this.policyId,sslCardNumber,sslCardShortDescription,sslCardType,sslCvv2Response,sslExpDate,sslTransactionType).pipe()
        .subscribe(
            data => {
              // this.editcreditCardDetails=data.data
              this.cardType=data.data.cardType
              // this.id=creditCardDetails[0].id
              this.sslCardNumber=data.data.sslCardNumber
              this.sslCardShortDescription=data.data.sslCardShortDescription
              this.sslCardType=data.data.sslCardType
              this.sslCvv2Response=data.data.sslCvv2Response
              this.sslExpDate=data.data.sslExpDate
              this.sslTransactionType=data.data.sslTransactionType
               
            },error=>{},()=>{});
      }
      onAgencyNavigation(event,data){
      if (event.ctrlKey==1){
        localStorage.setItem('agencyDetailsId', data)
        // sessionStorage.setItem('tabIndex', "document")
       //  var win = window.open('https://thzretail.com/TL/#/dashboard/edit-agencies/'+data, '_blank');
       var win = window.open('https://mytl.travelance.ca/TL/#/dashboard/edit-agencies/'+data, '_blank');
      // var win = window.open('https://mytl.travelance.ca/TL/#/dashboard/mga-details/'+data, '_blank');
    
        win.focus();
    }else{
    
      localStorage.setItem('agencyDetailsId', data)
    this.router.navigateByUrl('/dashboard/edit-agencies/'+data);
      setTimeout(() =>
       {
      location.reload();
      },
      350);
    }
  }
  onLeadNavigation(event,data){
    if (event.ctrlKey==1){
      localStorage.setItem('leadDetailsId', data);
   //    var win = window.open('https://thzretail.com/TL/#/dashboard/leads-details/'+data, '_blank');
     var win = window.open('https://mytl.travelance.ca/TL/#/dashboard/leads-details', '_blank');
  
      win.focus();
  }else{
    localStorage.setItem('leadDetailsId', data)
    // this.router.navigateByUrl('/dashboard/leads-details');
    this.router.navigateByUrl('/dashboard/leads-details/'+data);
  }
  }
      // new changes for step 2
  purchaserAddress1Flag: boolean=false;
  showAddressResults1: boolean=false;
  purchaseEmailFlag:boolean=false;
  purchasePhone1Flag: boolean=false;
  purchasePostalCodeFlag:boolean=false;
  purchaseCityFlag: boolean=false;
  confirmEmailMatch: boolean=false;
  purchaserAddress1: any;
  purchaserLastName: any;
  purchaserFirstName: any;
  purchasePostalCode: any;
  purchaseProvince: any;
  purchaseCity: any;
  purchasePhone1: any;
  purchasePhone2: any;
  purchaseEmail: any;
  purchaseEmailConfirm: any;
  emailNotValid: string="";
  getAddress1=[];
      onClickContactInfoNext(){
        var flag=true;
        // if(!this.form4.purchaserLastName.value){flag=true;this.purchaserLastNameFlag=true}else{flag=false;this.purchaserLastNameFlag=false}
        // if(!this.form4.purchaserFirstName.value){flag=true;this.purchaserFirstNameFlag=true}else{flag=false;this.purchaserFirstNameFlag=false}
        if(!this.purchaserAddress1){flag=false;this.purchaserAddress1Flag=true}else{this.purchaserAddress1Flag=false}
        // if(!this.form4.purchaseLanguage.value){flag=false;this.purchaseLanguageFlag=true}else{flag=true;this.purchaseLanguageFlag=false}
        if(!this.purchaseProvince){flag=false;this.purchaseProvinceFlag=true}else{this.purchaseProvinceFlag=false}
        if(!this.purchaseCity){flag=false;this.purchaseCityFlag=true}else{this.purchaseCityFlag=false}
        if(!this.purchasePostalCode){flag=false;this.purchasePostalCodeFlag=true}else{this.purchasePostalCodeFlag=false}
        if(!this.purchasePhone1){flag=false;this.purchasePhone1Flag=true}else{this.purchasePhone1Flag=false}
        // if(!this.form4.purchasePhone2.value){flag=false;this.purchasePhone2Flag=true}else{flag=true;this.purchasePhone2Flag=false}
        if(!this.purchaseEmail){flag=false;this.purchaseEmailFlag=true}else{this.purchaseEmailFlag=false}
        if(!this.insuredPersonArray[0].firstName){flag=false;this.firstNameFlag=true}else{this.firstNameFlag=false}
        if(!this.insuredPersonArray[0].lastName){flag=false;this.lastNameFlag=true}else{this.lastNameFlag=false}
        if(!this.insuredPersonArray[0].insitute){flag=false;this.InstituteFlag=true}else{this.InstituteFlag=false}
        if(!this.insuredPersonArray[0].homeCountry){flag=false;this.CountryFlag=true}else{this.CountryFlag=false}
    
        window.scrollTo(0, 0);
          this.showChangePolicy=true;
          this.showChangePolicyStepOne=false;
          this.showChangePolicyStepTwo=false;
          this.showChangePolicyStepTwoB=false;
          this.showChangePolicyStepThree=true;
          this.showChangePolicyStepThreeAdminFee=false;
          this.showChangePolicyStepFour=false;
          this.showChangePolicyStepFive=false;
          this.showSearchedPolicy=false;
          this.showPolicyDetails=false;
          this.showPolicySearch=false;
          this.showRefundPolicy=false;
          this.showAudtiLogs=false;
        if (flag == true && this.confirmEmailMatch == false) {    
          const request = 
          {      
            "agentId": this.agentId,
            "declaration": true,
            "deductableOptions": [
              {
                "amount": 0,
                "createdAt": "2022-04-27T05:08:15.125Z",
                "createdBy": "string",
                "id": 0,
                "lastModifiedBy": "string",
                "option": "string",
                "reduceAmount": 0,
                "updatedAt": "2022-04-27T05:08:15.125Z"
              }
            ],
            "language": this.selectedQuestionlanguages1,
            "noOfDays": this.calculatedDays,
            "optionalInformation": {
              "agentNote": this.comment,
              "beneficiary": this.beneficiary,
              "comment": this.agentNote
            },
            "paymentInformation": {
              "amount": 0,
              "cardNumber": "string",
              "cardType": "string",
              "cvv": "string",
              "expiryDate": "string"
            },
            "primaryAddress": {
              "address1": "",
              "address2": "",
              "city": "",
              "postalCode": "",
              "province": ""
            },
            "purchaserAddressSame": true,
            "questionsansers": this.questionAnsArray,
            "residentOf": this.selectedQuestionprovince1,
            "returnDate": this.expiryDate,
            "secondaryAddress": {
              "address1": "string",
              "address2": "string",
              "city": "string",
              "postalCode": "string",
              "province":"string"
            },
            "selectedPlan": this.selectedPlanSend,
            "startDate": this.startDate,
            "travellerInformation": this.travellerInfo,
            "travelllerDetails": this.insuredPersonArray,
            "visitorsToCanada": this.selectedQuestionAns1,
            "purchaserInformation":{
              "country": "",
              "emailAddress": this.purchaseEmail,
              "firstName": this.purchaserFirstName,
              "language": this.selectedQuestionlanguages1,
              "lastName": this.purchaserLastName,
              "phoneNumber1": this.purchasePhone1,
              "phoneNumber2": this.purchasePhone2,
              "postalCode": this.purchasePostalCode,
              "province": this.purchaseProvince,
              "purchaserAddress": {
                "address1": this.purchaserAddress1,
                "address2": this.purchaserAddress2,
                "city": this.purchaseCity,
                "postalCode": this.purchasePostalCode
            }}
           }
          // this.restService.callPostService(this.config.postApistep3, request).subscribe((data: any) => {
        this.base.callPostService(this.config.postApistep3, request).subscribe((data: any) => {
          // window.scrollTo(0, 0);
          // this.showChangePolicy=true;
          // this.showChangePolicyStepOne=false;
          // this.showChangePolicyStepTwo=true;
          // this.showChangePolicyStepTwoB=false;
          // this.showChangePolicyStepThree=true;
          // this.showChangePolicyStepThreeAdminFee=false;
          // this.showChangePolicyStepFour=false;
          // this.showChangePolicyStepFive=false;
          // this.showSearchedPolicy=false;
          // this.showPolicyDetails=false;
          // this.showPolicySearch=false;
          // this.showRefundPolicy=false;
        //this.step2SaveApiCall()
        // if(this.intStudPlanChecked==true || this.intStudPlanChecked1==true){
        //   this.showQuestionnaireQue=false;
        //   this.showDeclarationQuestionnaire=false;
        //   this.showChooseQuote=false;
        //   this.showIntStudPlan=true;
        //   this.showIntStudPlanStep1=false;
        //   this.showIntStudPlanPlanOption=false;
        //   this.showQuestionnaire=false;
        //   this.showQuestionnaireQue=false;
        //   this.showContactInfo=false;
        //   this.showPayment=true;
        //   this.showPaymentsDetails=false;
        // }
        // if(this.studAccidentIncChecked==true){
        //   this.showQuestionnaireQue=false;
        //   this.showDeclarationQuestionnaire=false;
        //   this.showChooseQuote=false;
        //   this.showIntStudPlan=true;
        //   this.showIntStudPlanStep1=false;
        //   this.showIntStudPlanPlanOption=false;
        //   this.showQuestionnaire=false;
        //   this.showQuestionnaireQue=false;
        //   this.showContactInfo=false;
        //   this.showPayment=true;
        //   this.showPaymentsDetails=false;
        // }
        //this.paymentCall();
        // this.step2SaveApiCall()
          // localStorage.removeItem('selectedQuestionprovince1');
          // localStorage.removeItem('selectedQuestionlanguages1');
          // setTimeout(() =>
          // {
          // this.finalStageTransactionCall();
          // },
          // 8000);
             }, error => {{
              if (error.status == 400) {
              }
            }
          }, () => { });
        } 
        
       }
  
  purchaseProvinceFlag: boolean=false;
  NonResidentSelected: boolean=false;
  comment: any;
  beneficiary: any;
  agentNote: any;
  onProvinceClick(){
    this.purchaseProvinceFlag=false;
    if(this.purchaseProvince == "Non-Resident of Canada"){
      this.NonResidentSelected=true
    }else{
      this.NonResidentSelected=false; 
    }
    }
    insuredPersonArray=[];  
    insuredPerson(){
      var obj={};
      obj["firstName"]=""
      obj["lastName"]=""
      obj["insitute"]=""
      obj["homeCountry"]="" 
      this.insuredPersonArray.push(obj);
      
    }
    declarationErrorFlag: boolean=true;
    onClickDeclaration(event){
      var flagCheck = event.target.checked;
      if(flagCheck==true){
      this.declarationErrorFlag=false;
      }else{
        this.declarationErrorFlag=true;
      
      }
          }
      
    step2SaveApiCall(){
      var flag=true;
      if(this.declarationErrorFlag == true){flag=false; this.declarationErrorFlag=true}else{this.declarationErrorFlag=false}
      if(flag){
      if(this.travellerInfo.length==2){
        
        this.insuredPerson();
      }
      if(this.travellerInfo.length==3){
        this.insuredPerson();
        this.insuredPerson();
      }
      if(this.travellerInfo.length==4){
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
      }
      if(this.travellerInfo.length==5){
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
      }
      if(this.travellerInfo.length==6){
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
      }
      if(this.travellerInfo.length==7){
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
      }
      if(this.travellerInfo.length==8){
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
      }
      if(this.travellerInfo.length==9){
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
        this.insuredPerson();
      }
        if (flag == true) {
      
          const request = 
          { 
            "agentId": this.agentId,
            "declaration": true,
            "deductableOptions": [
              {
                "amount": 0,
                "createdAt": "2022-04-27T05:08:15.125Z",
                "createdBy": "string",
                "id": 0,
                "lastModifiedBy": "string",
                "option": "string",
                "reduceAmount": 0,
                "updatedAt": "2022-04-27T05:08:15.125Z"
              }
            ],
            "language": this.selectedQuestionlanguages1,
            "noOfDays": this.calculatedDays,
            "optionalInformation": {
              "agentNote": "string",
              "beneficiary": "string",
              "comment": "string"
            },
            "paymentInformation": {
              "amount": 0,
              "cardNumber": "string",
              "cardType": "string",
              "cvv": "string",
              "expiryDate": "string"
            },
            "primaryAddress": {
              "address1": "string",
              "address2": "string",
              "city": "string",
              "postalCode": "string",
              "province":"string"
            },
            "purchaserAddressSame": true,
            "questionsansers": this.questionAnsArray,
            "residentOf": this.selectedQuestionprovince1,
            "returnDate": this.expiryDate,
            "secondaryAddress": {
              "address1": "string",
              "address2": "string",
              "city": "string",
              "postalCode": "string",
              "province":"string"
            },
            "selectedPlan": this.selectedPlanSend,
            "startDate": this.startDate,
            "travellerInformation": this.travellerInfo,
            "travelllerDetails": [
              {
                "arrivalDateInCanada": "",
                "country": "",
                "dateOfBirth": "",
                "dayTimePhone": "",
                "departureCity": "",
                "emailAddress": "",
                "firstName": "",
                "insitute": "",
                "language": "",
                "lastName": ""
              }
            ],
            "visitorsToCanada": this.selectedQuestionAns1,
            "purchaserInformation":{
              "country": "",
              "emailAddress": "",
              "firstName": "",
              "language": "",
              "lastName": "",
              "phoneNumber1": "",
              "phoneNumber2": "",
              "postalCode": "",
              "province": "",
              "purchaserAddress": {
                "address1": "",
                "address2": "",
                "city": "",
                "postalCode": ""
            }}
           }
            this.base.callPostService(this.config.postApistep2, request).subscribe((data: any) => {
              this.onClickQuestionnaireProceed();
             }, error => {
        
          }, () => { });
        }
      }
    }
  
    questionAnsArray: any[]=[];
    selectedPlanSend=[];
    onClickQuestionnaireProceed(){
      window.scrollTo(0, 0);
  
    }
    onCityClick(){
      this.purchaseCityFlag=false;
      }
      onEmailClick(){
        this.purchaseEmailFlag=false;  
        }
        onPhoneClick1(){
        this.purchasePhone1Flag=false;
        }
        onPostalCodeClick(){
        this.purchasePostalCodeFlag=false;
        }
        callAddressApiCall1(){
          this.purchaserAddress1Flag=false;
          this.showAddressResults1=true;
          this.purchaseProvince=false;
          this.purchasePostalCode=false;
          this.purchaseCity=false;
          this.user.getAddressCanada(this.purchaserAddress1).subscribe((data:any) =>{
           this.getAddress1 = data.Items;
          },error=>{{
          //handle Exception from Server 404,401
          }},()=>{});
        }
        getSelectedAddress1: any[]=[];
    onClickSearchResult1(item){
    this.purchaserAddress1=item.Text;
    this.showAddressResults1=false;
    this.user.getAddressCanadaSelected(item.Id).subscribe((data:any) =>{
      this.getSelectedAddress1 = data.Items;
      this.purchaseCity=this.getSelectedAddress1[0].City;
      this.purchasePostalCode=this.getSelectedAddress1[0].PostalCode;
      this.purchaseProvince=this.getSelectedAddress1[0].ProvinceName;
      // this.purchaseCityFlag=false;
      // this.purchasePostalCodeFlag=false;
      // this.purchaseProvinceFlag=false;
     },error=>{{
     }},()=>{})
  }
  provincesArray:any[]=[];
  getAllProvinces(){
    this.user.getProvincesBToB().subscribe((data:any) =>{
     this.provincesArray = data.data;
    },error=>{{
    }},()=>{});
  }
  // onSaveQuote3(){
  //   var flag=true;
  //   if(!this.quoteName){this.quoteNameFlag=true;flag=false}else{this.quoteNameFlag=false;flag=true}  
  //   if (flag == true) {    
  //     const request = 
  //     {      
  //       "agentId": this.agentId,
  //       "declaration": true,
  //       "deductableOptions": [
  //         {
  //           "amount": 0,
  //           "createdAt": "2022-04-27T05:08:15.125Z",
  //           "createdBy": "string",
  //           "id": 0,
  //           "lastModifiedBy": "string",
  //           "option": "string",
  //           "reduceAmount": 0,
  //           "updatedAt": "2022-04-27T05:08:15.125Z"
  //         }
  //       ],
  //       "language": this.selectedQuestionlanguages1,
  //       "noOfDays": this.calculatedDays,
  //       "optionalInformation": {
  //         "agentNote": this.comment,
  //         "beneficiary": this.beneficiary,
  //         "comment": this.agentNote
  //       },
  //       "paymentInformation": {
  //         "amount": 0,
  //         "cardNumber": "string",
  //         "cardType": "string",
  //         "cvv": "string",
  //         "expiryDate": "string"
  //       },
  //       "primaryAddress": {
  //         "address1": "",
  //         "address2": "",
  //         "city": "",
  //         "postalCode": "",
  //         "province": ""
  //       },
  //       "quoteDescriptions": this.quoteDescriptions,
  //       "quoteName": this.quoteName,
  //       "purchaserAddressSame": true,
  //       "questionsansers": this.questionAnsArray,
  //       "residentOf": this.selectedQuestionprovince1,
  //       "returnDate": this.expiryDate,
  //       "secondaryAddress": {
  //         "address1": "string",
  //         "address2": "string",
  //         "city": "string",
  //         "postalCode": "string",
  //         "province":"string"
  //       },
  //       "selectedPlan": this.selectedPlanSend,
  //       "startDate": this.startDate,
  //       "travellerInformation": this.travellerInfo,
  //       "travelllerDetails": this.insuredPersonArray,
  //       "visitorsToCanada": this.selectedQuestionAns1,
  //       "purchaserInformation":{
  //         "country": "",
  //         "emailAddress": this.purchaseEmail,
  //         "firstName": this.purchaserFirstName,
  //         "language": this.selectedQuestionlanguages1,
  //         "lastName": this.purchaserLastName,
  //         "phoneNumber1": this.purchasePhone1,
  //         "phoneNumber2": this.purchasePhone2,
  //         "postalCode": this.purchasePostalCode,
  //         "province": this.purchaseProvince,
  //         "purchaserAddress": {
  //           "address1": this.purchaserAddress1,
  //           "address2": this.purchaserAddress2,
  //           "city": this.purchaseCity,
  //           "postalCode": this.purchasePostalCode
  //       }}
  //      }
  //   this.base.callPostService(this.config.saveQuote, request).subscribe((data: any) => {
  //     this.quoteNameFlag=false;
  //     this.saveQuotesPopup=false;
  //     this.saveQuotesPopup1=false;
  //     this.saveQuotesPopup2=false;
  //     this.quoteName="";
  //     this.quoteDescriptions=""
  //     Swal.fire('',"Quote information saved.",'success');
     
  //        }, error => {{
  //         if (error.status == 400) {
  //         }
  //       }
  //     }, () => { });
  //   } 
    
  //  }
  popUpLanguageFlag:boolean=false;
  validateLanguage(data){
    if(data != null){
      this.popUpLanguageFlag=true;
    }
  }
  languagesArray: any=[];
  getAllLanguages(){
    this.user.getLanguageBToB().subscribe((data:any) =>{
     this.languagesArray = data.data;
    },error=>{{
    }},()=>{});
  }
  notValidPhoneNo: string="";
  checkPatternWork(){  
    var re = /^[0-9-+() ]*$/;
    if (!re.test(this.purchasePhone1.toLowerCase())) {
    this.notValidPhoneNo="Please enter valid Work Phone";
    }else{
      this.notValidPhoneNo=""
    }
    }
    checkConfirmEmail(){
      if(this.purchaseEmail && this.purchaseEmailConfirm){
        if(this.purchaseEmail==this.purchaseEmailConfirm){
          this.confirmEmailMatch = false;
        }else{
          this.confirmEmailMatch = true;
        }
      }
      
    }
    emailCheck(){
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(this.purchaseEmail.toLowerCase())){
        this.emailNotValid="Please enter valid Email";
      }else{
        this.emailNotValid="";
      }
      }
      printPopup:boolean=false;
      viewPaymentDetailsPopup:boolean=false;
      newNotePopup:boolean=false;
      email:any=[];
      email1:any;
      email2:any;
      emailErrorFlag:boolean=false;
      onRemoveEmailError(){
        this.emailErrorFlag=false;
        }
      
      onSendEmail(){
        this.email=[];
        if(!this.email1){this.emailErrorFlag=true}else{this.emailErrorFlag=false}
        if(this.emailErrorFlag==false){
          this.printPopup=false;
          this.email.push(this.email1)
          this.email.push(this.email2)
        this.userservice.getPolicyEmailSend(this.email,this.policyId).pipe().subscribe(data => {
          Swal.fire('','Email sent successfully.','success');
          },error=>{
          },()=>{});
      }
    }
      editEffectiveDate:boolean=false;
      editContactInfoName:boolean=false;
      editContactInfoAdderss:boolean=false;
      editContactInfoEmail:boolean=false;
      editContactInfoLanguage:boolean=false;
      editPurchaserInfoName:boolean=false;
      editPurchaserInfoAddress:boolean=false;
      editPurchaserInfoEmail:boolean=false;
      editPurchaserInfoPhoneOne:boolean=false;
      editPurchaserInfoPhoneTwo:boolean=false;
      editPurchaserInfoLanguage:boolean=false;
      updateEffectiveDate(){
        this.editEffectiveDate =! this.editEffectiveDate;
      }
      updateContactInfoName(){
        this.editContactInfoName =! this.editContactInfoName;
      }
      updateContactInfoAdderss(){
        this.editContactInfoAdderss=!this.editContactInfoAdderss;
      }
      updateContactInfoEmail(){
        this.editContactInfoEmail=!this.editContactInfoEmail;
      }
      updateContactInfoLanguage(){
        this.editContactInfoLanguage=!this.editContactInfoLanguage;
      }
      updatePurchaserInfoName(){
        this.editPurchaserInfoName=!this.editPurchaserInfoName;
      }
      updatePurchaserInfoAddress(){
        this.editPurchaserInfoAddress=!this.editPurchaserInfoAddress;
      }
      updatePurchaserInfoEmail(){
        this.editPurchaserInfoEmail=!this.editPurchaserInfoEmail;
      }
      updatePurchaserInfoPhoneOne(){
        this.editPurchaserInfoPhoneOne=!this.editPurchaserInfoPhoneOne;
      }
      updatePurchaserInfoPhoneTwo(){
        this.editPurchaserInfoPhoneTwo=!this.editPurchaserInfoPhoneTwo;
      }
      updatePurchaserInfoLanguage(){
        this.editPurchaserInfoLanguage=!this.editPurchaserInfoLanguage;
      }
      onLogsDetails(){
        // this.showChangePolicy=false;
        // this.showChangePolicyStepOne=false;
        // this.showChangePolicyStepTwo=false;
        // this.showChangePolicyStepTwoB=false;
        // this.showChangePolicyStepThree=false;
        // this.showChangePolicyStepThreeAdminFee=false;
        // this.showChangePolicyStepFour=false;
        // this.showChangePolicyStepFive=false;
        // this.showSearchedPolicy=false;
        // this.showPolicyDetails=false;
        // this.showPolicySearch=false;
        // this.showRefundPolicy=false;
        // this.showAudtiLogs=true;
        this.router.navigateByUrl('/dashboard/policy-audit-logs');
      }
      noteText:any;
      noteType:any;
      addNotesToPolicy(){
        this.newNotePopup=false;
        this.userservice.addNoteInPolicy(this.noteText,this.policyId,this.noteType).pipe().subscribe(data => {
          
          },error=>{
            this.newNotePopup=false;
          },()=>{});
    }
    adminfeeerror:boolean=false
    adminFeeReasonerror:boolean=false
    onadminFeeClick(){
      
      this.adminfeeerror=false
      var s = this.PrevAmount;
      while(s.charAt(0) === '$')
      {
       s = s.substring(1);
      }
      console.log(s)
       s=s.replace (/,/g, "");
      //  s=s*-1
      this.Amount=s-this.adminFee
      console.log(this.Amount)
      this.Amount = this.Amount.toFixed(2);
    }
    onadminFeeReasonClick(){
      
      this.adminFeeReasonerror=false
    }
    PaymentType:any
    changePaymentType(a){
      
      if(a==null){
        this.cardType1=""
        this.CardNumber1=""
        this.cardexpdate1=""
        this.showCardNo1=false
        this.showCVV1=false
        this.showexp1=false
      }
      // if(a==this.ssl_card_number || a==""){
      //   this.cardType1=this.ssl_card_number
      //   // this.CardNumber1=ct
      //   this.cardexpdate1=this.ssl_exp_date
      if(a.id){
        // if(a==this.ssl_card_number || a==""){
        this.cardType1=a.transactionPaymentDetails[0].sslCardNumber
        this.ssl_card_number=a.transactionPaymentDetails[0].sslCardNumber
    // this.cardType1=this.ssl_card_number
    // this.CardNumber1=ct
    // this.cardexpdate1=this.ssl_exp_date
    this.cardexpdate1=a.transactionPaymentDetails[0].sslExpDate
    this.txnId = a.transactionPaymentDetails[0].sslTxnId;
    this.paymentTokenNew=a.transactionPaymentDetails[0].sslToken;
      this.showCardNo1=false
      this.showCVV1=false
      this.showexp1=true
      }
      else{
        this.showCVV1=true
        this.showCardNo1=true
        this.showexp1=true
      }
    }
    changePaymentType2(a){
      
      if(a==null){
        this.cardType2=""
        this.CardNumber2=""
        this.cardexpdate2=""
        this.showCardNo2=false
        this.showCVV2=false
        this.showexp2=false
      }
      if(a.id){
        // if(a==this.ssl_card_number || a==""){
        this.cardType2=a.transactionPaymentDetails[0].sslCardNumber
        this.ssl_card_number=a.transactionPaymentDetails[0].sslCardNumber
    // this.cardType1=this.ssl_card_number
    // this.CardNumber1=ct
    // this.cardexpdate1=this.ssl_exp_date
    this.cardexpdate2=a.transactionPaymentDetails[0].sslExpDate
    this.txnId = a.transactionPaymentDetails[0].sslTxnId;
    this.paymentTokenNew=a.transactionPaymentDetails[0].sslToken;
        this.showCardNo2=false
        this.showCVV2=false
        this.showexp2=true
      }
      else{
        this.showCVV2=true
        this.showCardNo2=true
        this.showexp2=true
      }
    }
    changePaymentType3(a){
      if(a==null){
        this.cardType3=""
        this.CardNumber3=""
        this.cardexpdate3=""
        this.showCardNo3=false
        this.showCVV3=false
        this.showexp3=true
      }
      if(a.id){
        // if(a==this.ssl_card_number || a==""){
        this.cardType3=a.transactionPaymentDetails[0].sslCardNumber
        this.ssl_card_number=a.transactionPaymentDetails[0].sslCardNumber
    // this.cardType1=this.ssl_card_number
    // this.CardNumber1=ct
    // this.cardexpdate1=this.ssl_exp_date
    this.cardexpdate3=a.transactionPaymentDetails[0].sslExpDate
    this.txnId = a.transactionPaymentDetails[0].sslTxnId;
    this.paymentTokenNew=a.transactionPaymentDetails[0].sslToken;
        this.showCardNo3=false
        this.showCVV3=false
        this.showexp3=true
      }
      else{
        this.showCVV3=true
        this.showCardNo3=true
        this.showexp3=true
      }
    }
    changePaymentType4(a){
      if(a==null){
        this.cardType4=""
        this.CardNumber4=""
        this.cardexpdate4=""
        this.showCardNo4=false
        this.showCVV4=false
        this.showexp4=false
      }
      if(a.id){
        // if(a==this.ssl_card_number || a==""){
        this.cardType4=a.transactionPaymentDetails[0].sslCardNumber
        this.ssl_card_number=a.transactionPaymentDetails[0].sslCardNumber
    // this.cardType1=this.ssl_card_number
    // this.CardNumber1=ct
    // this.cardexpdate1=this.ssl_exp_date
    this.cardexpdate4=a.transactionPaymentDetails[0].sslExpDate
    this.txnId = a.transactionPaymentDetails[0].sslTxnId;
    this.paymentTokenNew=a.transactionPaymentDetails[0].sslToken;
        this.showCardNo4=false
        this.showCVV4=false
        this.showexp4=true
      }
      else{
        this.showCVV4=true
        this.showCardNo4=true
        this.showexp4=true
      }
    }
    changePaymentType5(a){
      if(a==null){
        this.cardType5=""
        this.CardNumber5=""
        this.cardexpdate5=""
        this.showCardNo5=false
        this.showCVV5=false
        this.showexp5=false
      }
      if(a.id){
        // if(a==this.ssl_card_number || a==""){
        this.cardType5=a.transactionPaymentDetails[0].sslCardNumber
        this.ssl_card_number=a.transactionPaymentDetails[0].sslCardNumber
    // this.cardType1=this.ssl_card_number
    // this.CardNumber1=ct
    // this.cardexpdate1=this.ssl_exp_date
    this.cardexpdate5=a.transactionPaymentDetails[0].sslExpDate
    this.txnId = a.transactionPaymentDetails[0].sslTxnId;
    this.paymentTokenNew=a.transactionPaymentDetails[0].sslToken;
        this.showexp5=true
        this.showCardNo5=false
        this.showCVV5=false
      }
      else{
        this.showCVV5=true
        this.showCardNo5=true
        this.showexp5=true
      }
      
    }
    isDisabled: boolean = false;
    goToQuotePurchase(){
      if(this.isDisabled){
        return;
      }
      if(this.hideQuotePurchase!="true"){
        this.router.navigateByUrl('/dashboard/Quotes-Purchase');
      }else{
        Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
      }
    }
    CCExpdate1(){
        
      var re=/(0[1-9]|1[0-2])\/?([0-9]{2})$/mg
      if(!re.test(this.cardexpdate1)){
        this.cardexpdate1Flag=true
      }else{
        this.cardexpdate1Flag=false;
     
      this.cardexpdate1Flag=false
      this.cardexpdateFlagButtonDisable=false
      
        
    if(this.cardexpdate1.charAt(2) === '/'){
      this.expDate1ToSend=this.cardexpdate1.substring(0, 2);
      this.expDateYearToSend=this.cardexpdate1.substring(3, 5)
    }
    else{
    
    this.expDate1ToSend=this.cardexpdate1.substring(0, 2);
    this.expDateYearToSend=this.cardexpdate1.substring(2, 4)
  }
    const d = new Date();
    let month = getMonth(d);
    function getMonth(date) {
      var month = date.getMonth() + 1;
      return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
    }  
    
    const last2 = new Date().getFullYear().toString().slice(-2);
    console.log(last2); // 👉️ has type of string
    const last2Num = Number(last2);
    
      console.log(month)
      console.log(last2Num)
      console.log(this.expDate1ToSend)
      console.log(this.expDateYearToSend)
      if(this.expDateYearToSend<last2Num)
      {
        this.cardexpdate1Flag=true
        this.cardexpdateFlagButtonDisable=true
      }
      else{
        this.cardexpdate1Flag=false
    this.cardexpdateFlagButtonDisable=false
    if(this.expDate1ToSend<month && this.expDateYearToSend<=last2Num)
    {
     
      this.cardexpdate1Flag=true
      this.cardexpdateFlagButtonDisable=true
    }
    
  }
      if(this.cardType1=='VISA' || this.cardType1=='MasterCard' || this.cardType1=='AmericanExpress'){
        this.showCardNo1=true;
      }else{
        this.showCardNo1=false;
      }
      this.showCVV1=false
      this.showexp1=true
    }
    }
    CCExpdate2(){
      var re=/(0[1-9]|1[0-2])\/?([0-9]{2})$/mg
      if(!re.test(this.cardexpdate2)){
        this.cardexpdate2Flag=true
      }else{
       
      this.cardexpdate2Flag=false
      this.cardexpdateFlagButtonDisable=false
     
    if(this.cardexpdate2.charAt(2) === '/'){
      this.expDate1ToSend=this.cardexpdate2.substring(0, 2);
      this.expDateYearToSend=this.cardexpdate2.substring(3, 5)
    }
    else{
    
    this.expDate1ToSend=this.cardexpdate2.substring(0, 2);
    this.expDateYearToSend=this.cardexpdate2.substring(2, 4)
  }
   
    const d = new Date();
    let month = getMonth(d);
    function getMonth(date) {
      var month = date.getMonth() + 1;
      return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
    }  
    
    const last2 = new Date().getFullYear().toString().slice(-2);
    console.log(last2); // 👉️ has type of string
    const last2Num = Number(last2);
    
      console.log(month)
      console.log(last2Num)
      console.log(this.expDate1ToSend)
      console.log(this.expDateYearToSend)
      if(this.expDateYearToSend<last2Num)
      {
        this.cardexpdate2Flag=true
        this.cardexpdateFlagButtonDisable=true
      }
      else{
        this.cardexpdate2Flag=false
    this.cardexpdateFlagButtonDisable=false
    if(this.expDate1ToSend<month && this.expDateYearToSend<=last2Num)
    {
     
      this.cardexpdate2Flag=true
      this.cardexpdateFlagButtonDisable=true
    }
    
  }
  
      if(this.cardType2=='VISA' || this.cardType2=='MasterCard' || this.cardType2=='AmericanExpress'){
        this.showCardNo2=true;
      }else{
        this.showCardNo2=false;
      }
      this.showCVV2=false
      this.showexp2=true
    }
      
    }
    CCExpdate3(){
      var re=/(0[1-9]|1[0-2])\/?([0-9]{2})$/mg
      if(!re.test(this.cardexpdate3)){
        this.cardexpdate3Flag=true
      }else{
        this.cardexpdate3Flag=false
      this.cardexpdate3Flag=false
      this.cardexpdateFlagButtonDisable=false
      
      if(this.cardexpdate3.charAt(2) === '/'){
        this.expDate1ToSend=this.cardexpdate3.substring(0, 2);
        this.expDateYearToSend=this.cardexpdate3.substring(3, 5)
      }
      else{
      
      this.expDate1ToSend=this.cardexpdate3.substring(0, 2);
      this.expDateYearToSend=this.cardexpdate3.substring(2, 4)
    }
   
    const d = new Date();
    let month = getMonth(d);
    function getMonth(date) {
      var month = date.getMonth() + 1;
      return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
    }  
    
    const last2 = new Date().getFullYear().toString().slice(-2);
    console.log(last2); // 👉️ has type of string
    const last2Num = Number(last2);
    
      console.log(month)
      console.log(last2Num)
      console.log(this.expDate1ToSend)
      console.log(this.expDateYearToSend)
      if(this.expDateYearToSend<last2Num)
      {
        this.cardexpdate3Flag=true
        this.cardexpdateFlagButtonDisable=true
      }
      else{
        this.cardexpdate3Flag=false
        this.cardexpdateFlagButtonDisable=false
    if(this.expDate1ToSend<month && this.expDateYearToSend<=last2Num)
    {
     
      this.cardexpdate3Flag=true
      this.cardexpdateFlagButtonDisable=true
    }
   
  }
  
      if(this.cardType3=='VISA' || this.cardType3=='MasterCard' || this.cardType3=='AmericanExpress'){
        this.showCardNo3=true;
      }else{
        this.showCardNo3=false;
      }
      this.showCVV3=false
      this.showexp3=true
    }
      
    }
    CCExpdate4(){
       var re=/(0[1-9]|1[0-2])\/?([0-9]{2})$/mg
      if(!re.test(this.cardexpdate4)){
        this.cardexpdate4Flag=true
      }else{
        
      this.cardexpdate4Flag=false
      this.cardexpdateFlagButtonDisable=false
      if(this.cardexpdate4.charAt(2) === '/'){
        this.expDate1ToSend=this.cardexpdate4.substring(0, 2);
        this.expDateYearToSend=this.cardexpdate4.substring(3, 5)
      }
    
    else{
    
    this.expDate1ToSend=this.cardexpdate4.substring(0, 2);
    this.expDateYearToSend=this.cardexpdate4.substring(2, 4)
  }
    
    
         
    const d = new Date();
    let month = getMonth(d);
    function getMonth(date) {
      var month = date.getMonth() + 1;
      return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
    }  
    
    const last2 = new Date().getFullYear().toString().slice(-2);
    console.log(last2); // 👉️ has type of string
    const last2Num = Number(last2);
    
      console.log(month)
      console.log(last2Num)
      console.log(this.expDate1ToSend)
      console.log(this.expDateYearToSend)
      if(this.expDateYearToSend<last2Num)
      {
        this.cardexpdate4Flag=true
        this.cardexpdateFlagButtonDisable=true
      }
      else{
        this.cardexpdate4Flag=false
    this.cardexpdateFlagButtonDisable=false
    if(this.expDate1ToSend<month && this.expDateYearToSend<=last2Num)
    {
     
      this.cardexpdate4Flag=true
      this.cardexpdateFlagButtonDisable=true
    }
    
  }
  
      if(this.cardType4=='VISA' || this.cardType4=='MasterCard' || this.cardType4=='AmericanExpress'){
        this.showCardNo4=true;
      }else{
        this.showCardNo4=false;
      }
      this.showCVV4=false
      this.showexp4=true
      
    }
    }
    CCExpdate5(){
      var re=/(0[1-9]|1[0-2])\/?([0-9]{2})$/mg
      if(!re.test(this.cardexpdate5)){
        this.cardexpdate5Flag=true
      }else{
      this.cardexpdate5Flag=false
      this.cardexpdateFlagButtonDisable=false
      
      if(this.cardexpdate5.charAt(2) === '/'){
        this.expDate1ToSend=this.cardexpdate5.substring(0, 2);
        this.expDateYearToSend=this.cardexpdate5.substring(3, 5)
      }
    
    else{
    
    this.expDate1ToSend=this.cardexpdate5.substring(0, 2);
    this.expDateYearToSend=this.cardexpdate5.substring(2, 4)
  }
    const d = new Date();
    let month = getMonth(d);
    function getMonth(date) {
      var month = date.getMonth() + 1;
      return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
    }  
    
    const last2 = new Date().getFullYear().toString().slice(-2);
    console.log(last2); // 👉️ has type of string
    const last2Num = Number(last2);
    
      console.log(month)
      console.log(last2Num)
      console.log(this.expDate1ToSend)
      console.log(this.expDateYearToSend)
      if(this.expDateYearToSend<last2Num)
      {
        this.cardexpdate5Flag=true
        this.cardexpdateFlagButtonDisable=true
      }
      else{
        this.cardexpdate5Flag=false
    this.cardexpdateFlagButtonDisable=false
    if(this.expDate1ToSend<month && this.expDateYearToSend<=last2Num)
    {
     
      this.cardexpdate5Flag=true
      this.cardexpdateFlagButtonDisable=true
    }
    
  }
  
  if(this.cardType5=='VISA' || this.cardType5=='MasterCard' || this.cardType5=='AmericanExpress'){
    this.showCardNo5=true;
  }else{
    this.showCardNo5=false;
  }
  this.showCardNo5=false
  this.showCVV5=false
}
      
    }
    getLeadAgentsCodes(){
      this.user.getLeadAgentsCodes(this.leadsId).pipe()
      .subscribe(
        data => {
        // console.log(data);
        // this.agentcodedata=[];
      ////
        // this.agentIdActive=sessionStorage.getItem('agentIdActive');
        for(let i=0;i<data.data.agentCodes.length;i++){
          if(this.agentId==data.data.agentCodes[i].id){
            if(data.data.agentCodes[i].status=="Active" || data.data.agentCodes[i].status=="Primary")
            {
            this.agentIdActive='true'
            }
            else{
              this.agentIdActive='false'
            }
          }
         // this.agentcodedata.push(data.data.agentCodes[i])
          // console.log(this.agentcodedata)
        }
        }, error => {
    
          // if (error.status == 400 || error.status == 417) {
          //   this.error = error.error.data;
          // }
          // else {
          //   this.error = "Something went wrong. Please check username and password.";
          // }
        }, () => { });
      }
      goToSalesHome(){
        if(this.agentIdActive=='true'){
          this.router.navigateByUrl('/dashboard/sales-home');
        }else{
          // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
        }
  
      }
  goToPolicySearch(){
    if(this.agentIdActive=='true'){
      this.router.navigateByUrl('/dashboard/policy-search');
    }else{
      // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
    }
  
  }
  goToSaveQuote(){
    
    if(this.agentIdActive=='true'){
      this.router.navigateByUrl('/dashboard/Save-Quotes');
    }else{
      // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
    }
  }
  goToforms(){
    
    if(this.agentIdActive=='true'){
      this.router.navigateByUrl('/dashboard/forms');
    }else{
      // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
    }
  }
  goToResources(){
    if(this.agentIdActive=='true'){
      this.router.navigateByUrl('/dashboard/resources');
    }else{
      // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
    }
  
  }
  getDashboard() {
    this.user.getDashboardData().pipe()
      .subscribe(
        data => {
          this.leadStatus=data.data.leads.leadStatus;
          if(this.leadStatus == 'Deactivated'){
            this.isDisabled = true;
          } else{
            this.isDisabled = false;
          }
         }, error => {
        }, () => { });
  }
  }